import { TABLE_GRID } from 'modules/listIndex/constants';
import { List } from 'modules/listIndex/types';
import { NameCell } from './NameCell';
import { TypeCell } from './TypeCell';
import { UsersCell } from './UsersCell';
import { LastModifiedCell } from './lastModified';
import { RowOverflowMenuCell } from './RowOverflowMenuCell';
import { StyledGridRow } from './styles';

type Props = {
  list: List;
};

/** Creates singular table row column */
export const ListRow = ({ list }: Props) => {
  return (
    <StyledGridRow gridLayout={TABLE_GRID} key={list.id}>
      <NameCell row={list} />
      <TypeCell row={list} />
      <UsersCell row={list} />
      <LastModifiedCell row={list} />
      <RowOverflowMenuCell row={list} />
    </StyledGridRow>
  );
};
